module.exports = __webpack_public_path__ + "static/cubic_zirconia-3c7a9d3d350c51732e5a19b81f327469.svg";